/**
 * Set of websites reviews are sourced from.
 */
export const enum REVIEW_SOURCE {
  GOOGLE = 'google',
  PRODUCT_REVIEW = 'productReview',
}
